import { Injectable } from '@angular/core';
import { SearchbarState } from '../searchbar-v2-state';

@Injectable()
export class FilterService {
    private _lastFilter: SearchbarState;
    constructor() {
        this._lastFilter = new SearchbarState();
    }

    public getLastFilter(): SearchbarState {
        return this._lastFilter;
    }

    public setLastFilter(lastFilter: SearchbarState) {
        this._lastFilter = lastFilter;
    }
}
